// ApplyGate (03-dominio.md, RN64, RN26): when «Apply correction» can be pressed. One condition per field so each is tested alone.
//   `blockedBy` names the first thing that stops it. There is no plant switch (DPO-1): only the permission
//   DATA_CORRECTION_REQUEST enables applying. Story 211 drops the old «open» block and adds the confirmation of «close now».

export const canApply = ({ canRequest, vigent, reasonChosen, commentValid, applying, reasonsLoaded, closeNowMode = false, closeNowConfirmed = false }) => {
  if (!canRequest) return { enabled: false, blockedBy: 'permission' }
  if (!reasonsLoaded) return { enabled: false, blockedBy: 'reasons' }
  if (applying) return { enabled: false, blockedBy: 'applying' }
  if (!vigent) return { enabled: false, blockedBy: 'preview' }
  if (!reasonChosen) return { enabled: false, blockedBy: 'reason' }
  if (!commentValid) return { enabled: false, blockedBy: 'comment' }
  if (closeNowMode && !closeNowConfirmed) return { enabled: false, blockedBy: 'confirmation' }
  return { enabled: true, blockedBy: '' }
}
